import moment from "moment";
import React from "react";
import { orderIsCancelled, orderIsFullyRefunded } from "../Helpers/OderUtils";
import "../Styles/_OrderCancelledInformation.css";
import { Confirmed } from "./_Icon";

const OrderRefundedInformation = ({ currentLanguage, order }) => {
    if (orderIsCancelled(order) || !orderIsFullyRefunded(order)) {
        return false;
    }

    return (
        <div className="cancelled-container">
            <div className="cancelled-container-label">
                <Confirmed fill="#BF0000" />
                <p>
                    {`${currentLanguage.ORDER_PAGE.REFUNDED_SECTION.REFUNDED_MESSAGE} `}
                    {moment(order.refunded_at).format("LL")}
                </p>
            </div>
        </div>
    );
};

export default OrderRefundedInformation;
